export class RequestStrings {
  static CONNECTION_ERROR_MSG =
    'We were unable to connect to our servers. ' +
    'Please make sure you are online and have disabled ad blockers, if any.';

  static INVALID_INPUT_MSG = 'Invalid Input Provided';

  static CONNECTION_ERROR_SHORT = 'Connection Error! We were unable to connect to our servers.';
}
